document.addEventListener('DOMContentLoaded', buildScrollNav);

    function stripHtml(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    }

    function buildScrollNav() {
        const article = document.querySelector('article.detail');
    const navList = document.querySelector('ul.nav-scroll');

    if (!article || !navList) return;

    const scrollLinks = article.querySelectorAll('.scroll-link');

        scrollLinks.forEach(el => {
            const id = el.getAttribute('id');
    const text = el.getAttribute('data-scroll');

    if (!id || !text) return;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = stripHtml(text);

            a.addEventListener('click', e => {
        e.preventDefault();
    document.getElementById(id)?.scrollIntoView({behavior: 'smooth', block: 'start' });
            });

    li.appendChild(a);
    navList.appendChild(li);
        });

    initScrollSpy();
    }

    function initScrollSpy() {
        const navLinks = document.querySelectorAll('ul.nav-scroll a');

        const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const active = document.querySelector(`ul.nav-scroll a[href="#${entry.target.id}"]`);
            if (!active) return;

            if (entry.isIntersecting) {
                active.classList.add('active');
            } else {
                active.classList.remove('active');
            }
        });
        }, {
        rootMargin: '128px 0px -80% 0px',
    threshold: 0
        });

        document.querySelectorAll('article.detail .scroll-link').forEach(el => observer.observe(el));
}
